/**
 * @file 选择城市/门店/时间
 */

import React, {Component} from 'react';
import {
    SAVE_CITY_GAI_INFO,
    SAVE_CITY_GET_INFO,
    SAVE_STORE_GAI_INFO,
    SAVE_STORE_GET_INFO,
    SAVE_START_TIME,
    SAVE_END_TIME
} from '../../redux/actions/homeAction';
import {parseStateToSearch, parseSearchToState} from '../../util/util.js';
import moment from 'moment';
import {List, Calendar, Button, Toast} from 'antd-mobile';
import {connect} from 'react-redux';
import './index.scss';
const Item = List.Item;
const now = new Date(Date.now() + 2 * 60 * 60 * 1000);
const weekday = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

class Search extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            // 下单时间与取车时间的最小时间间隔（单位：小时）
            createOrderMinHours: 2,
            // 超过几小时就算1整天
            hourExceedsThresholdToOneDay: 4,
            dateDiffNum: 2,
            startTime: JSON.parse(sessionStorage.getItem('startTime')),
            endTime: JSON.parse(sessionStorage.getItem('endTime'))
        };
    }

    componentDidMount() {
        let {startTime, endTime} = this.state;
        let sTime = `${startTime.year}/${startTime.month}/${startTime.day} ${startTime.hours}:${startTime.minutes}`;
        let eTime = `${endTime.year}/${endTime.month}/${endTime.day} ${endTime.hours}:${endTime.minutes}`;
        this.getDateDiffNum(sTime, eTime);
    }

    getDateDiffNum(sTime, eTime) {
        let date1 = new Date(sTime);
        let date2 = new Date(eTime);
        let yuNum = 0;

        // 总小时
        let dateDiffNum = (date2.getTime() - date1.getTime()) / (1000 * 60 * 60);
  
        // 取整天
        let zNum = parseInt(dateDiffNum / 24);
  
        if (zNum > 0) {
            // 小于4小时的算一天
            yuNum = dateDiffNum % 24 < 4 ? 0 : 1;
        }
        // 总天数
        dateDiffNum = zNum + yuNum;
  
        if (Number(dateDiffNum) >= 1) {
            this.setState({
                dateDiffNum: parseInt(dateDiffNum)
            });
            return true;
        }
        return false;
    }

    docheckStartHours(startTime) {
        let currentHours = Date.now();
        let hours = new Date(startTime).getTime();
        let {createOrderMinHours} = this.state;
        return (hours - currentHours) > createOrderMinHours * 60 * 60 * 1000;
    }

    onCancel = () => {
        this.setState({
            show: false
        });
    }

    onConfirm = (startTime, endTime) => {
        let checkDateRange = this.getDateDiffNum(startTime, endTime);
        let checkHours = this.docheckStartHours(startTime);
        let {createOrderMinHours} = this.state;
        if (!checkDateRange) {
            Toast.info('租期至少为一天，请重新选择');
            return false;
        }
        if (!checkHours) {
            Toast.info(`预约取车时间距离当前时间小于${createOrderMinHours}小时不能下单`);
            return false;
        }

        let startTimeObj = {
            year: startTime.getFullYear(),
            month: startTime.getMonth() + 1,
            day: startTime.getDate(),
            week: weekday[startTime.getDay()],
            hours: startTime.getHours(),
            minutes: startTime.getMinutes()
        };

        let endTimeObj = {
            year: endTime.getFullYear(),
            month: endTime.getMonth() + 1,
            day: endTime.getDate(),
            week: weekday[endTime.getDay()],
            hours: endTime.getHours(),
            minutes: endTime.getMinutes()
        };

        sessionStorage.setItem('startTime', JSON.stringify(startTimeObj));
        sessionStorage.setItem('endTime', JSON.stringify(endTimeObj));
        this.setState({
            startTime: startTimeObj,
            endTime: endTimeObj,
            show: false
        });

    }

    gotoChooseCity = cityCode => {
        const {history} = this.props;
        const search = history.location.search;
        let carListParams = parseSearchToState(search);
        history.push({
            pathname: '/city',
            search: parseStateToSearch({cityCode, pathname: '/carList', ...carListParams, cityclasses: cityCode})
        });
    }

    gotoChooseStore = cityCode => {
        const {history} = this.props;
        const search = history.location.search;
        let params = '';
        let carListParams = parseSearchToState(search);
        if (+cityCode === 1) {
            params = {
                cityName: carListParams.gaiCityId,
                coordinatePoint: carListParams.gaicoordinatePoint,
                cityId: carListParams.gaiCityId
            };
        } else {
            params = {
                cityName: carListParams.getCityId,
                coordinatePoint: carListParams.getcoordinatePoint,
                cityId: carListParams.getCityId
            };
        }
        sessionStorage.setItem('carListParams', JSON.stringify(carListParams));
        history.push({
            pathname: '/stores',
            search: parseStateToSearch({cityclasses: cityCode, ...params, ...carListParams, pathname: history.location.pathname})
        });
    }

    pad = time => time >= 10 ? time : `0${time}`;

    // 车型选择页面点击立即租车
    saveEdit() {
        let {startTime, endTime, dateDiffNum} = this.state;
        let gaiStoreInfo = JSON.parse(sessionStorage.getItem('gaiStoreInfoFromStores'));
        let getStoreInfo = JSON.parse(sessionStorage.getItem('getStoreInfoFromStores'));
        this.props.dispatch(SAVE_CITY_GAI_INFO({gaiCityInfo: JSON.parse(sessionStorage.getItem('gaiCityInfoFromStores'))}));
        this.props.dispatch(SAVE_CITY_GET_INFO({getCityInfo: JSON.parse(sessionStorage.getItem('getCityInfoFromStores'))}));
        this.props.dispatch(SAVE_STORE_GAI_INFO({gaiStoreInfo: gaiStoreInfo}));
        this.props.dispatch(SAVE_STORE_GET_INFO({getStoreInfo: getStoreInfo}));
        this.props.dispatch(SAVE_START_TIME({startTime}));
        this.props.dispatch(SAVE_END_TIME({endTime}));
        this.props.callback();
        this.changeURLPar({
            startTime: `${startTime.month}-${startTime.day} ${this.pad(startTime.hours)}:${this.pad(startTime.minutes)}`,
            endTime: `${endTime.month}-${endTime.day} ${this.pad(endTime.hours)}:${this.pad(endTime.minutes)}`,
            sTime: `${startTime.year}-${this.pad(startTime.month)}-${this.pad(startTime.day)} ${this.pad(startTime.hours)}:${this.pad(startTime.minutes)}:00`,
            eTime: `${endTime.year}-${this.pad(endTime.month)}-${this.pad(endTime.day)} ${this.pad(endTime.hours)}:${this.pad(endTime.minutes)}:00`,
            dateDiffNum,
            hourExceedsThresholdToOneDay: 4,
            gaiCityId: gaiStoreInfo.cityId,
            gaiCityName: gaiStoreInfo.cityName,
            gaiStoreId: gaiStoreInfo.storeId,
            gaiStoreName: gaiStoreInfo.storeName,
            gaicoordinatePoint: `${gaiStoreInfo.longitude},${gaiStoreInfo.latitude}`,
            getCityId: getStoreInfo.cityId,
            getCityName: getStoreInfo.cityName,
            getStoreId: getStoreInfo.storeId,
            getStoreName: getStoreInfo.storeName,
            getcoordinatePoint: `${getStoreInfo.longitude},${getStoreInfo.latitude}`
        });
    }

    changeURLPar(params) {
        let hash = window.location.hash.split('?')[0];
        let str = '?';
        for (let key in params) {
            str += `${key}=${params[key]}&`;
        }
        window.history.pushState(null, null, `${hash}${str}`);
    }

    render() {
        let gaiCityInfo = JSON.parse(sessionStorage.getItem('gaiCityInfo'));
        let getCityInfo = JSON.parse(sessionStorage.getItem('getCityInfo'));
        let gaiStoreInfo = JSON.parse(sessionStorage.getItem('gaiStoreInfo'));
        let getStoreInfo = JSON.parse(sessionStorage.getItem('getStoreInfo'));
        if (this.props.fromPath === '/stores') {
            gaiCityInfo = JSON.parse(sessionStorage.getItem('gaiCityInfoFromStores'));
            getCityInfo = JSON.parse(sessionStorage.getItem('getCityInfoFromStores'));
            gaiStoreInfo = JSON.parse(sessionStorage.getItem('gaiStoreInfoFromStores'));
            getStoreInfo = JSON.parse(sessionStorage.getItem('getStoreInfoFromStores'));
        }
        let {startTime, endTime, dateDiffNum} = this.state;
        return (
            <div>
                <div className="select-box">
                    <List renderHeader={() => '取车门店'} className="my-list">
                        <Item multipleLine>
                            <div className="search-city" onClick={() => this.gotoChooseCity('1')}>{gaiCityInfo.cityName}</div>
                            <div className="search-store" onClick={() => this.gotoChooseStore('1')}>{gaiStoreInfo.storeName}</div>
                        </Item>
                    </List>
                    <List renderHeader={() => '还车门店'} className="my-list">
                        <Item multipleLine>
                            <div className="search-city" onClick={() => this.gotoChooseCity('2')}>{getCityInfo.cityName}</div>
                            <div className="search-store" onClick={() => this.gotoChooseStore('2')}>{getStoreInfo.storeName}</div>
                        </Item>
                    </List>
                    <div className="date-select">
                        <div
                            className="start-datetime"
                            onClick={() => {
                                this.setState({
                                    show: true
                                });
                            }}
                        >
                            <div className="search-date">{startTime.month}月{startTime.day}日</div>
                            <div className="search-time">
                                {startTime.week}
                                {this.pad(startTime.hours)}:{this.pad(startTime.minutes)}
                            </div>
                        </div>
                        <div className="search-date-num">
                            <div>{dateDiffNum}天</div>
                            <div className="search-line"></div>
                        </div>
                        <div
                            className="end-datetime"
                            onClick={() => {
                                this.setState({
                                    show: true
                                });
                            }}
                        >
                            <div className="search-date">{endTime.month}月{endTime.day}日</div>
                            <div className="search-time">
                                {endTime.week}
                                {this.pad(endTime.hours)}:{this.pad(endTime.minutes)}
                            </div>
                        </div>
                    </div>
                    <Button type="warning" className="search-btn" onClick={() => this.saveEdit()}>搜索修改</Button>
                </div>
                <Calendar
                    pickTime={true}
                    visible={this.state.show}
                    onCancel={this.onCancel}
                    onConfirm={this.onConfirm}
                    defaultDate={now}
                    minDate={new Date(`${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`)}
                    maxDate={new Date(+now + (8.64e7 * 89))}
                    defaultValue={[
                        new Date(`${startTime.year}/${startTime.month}/${startTime.day} ${startTime.hours}:${startTime.minutes}`),
                        new Date(`${endTime.year}/${endTime.month}/${endTime.day} ${endTime.hours}:${endTime.minutes}`)
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    let params = state.homeReducer;
    return {
        gaiCityInfo: params.gaiCityInfo,
        getCityInfo: params.getCityInfo,
        gaiStoreInfo: params.gaiStoreInfo,
        getStoreInfo: params.getStoreInfo,
        startTime: params.startTime,
        endTime: params.endTime
    };
};

Search = connect(mapStateToProps)(Search);

export default Search;